import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from 'react-modal';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import { connect } from 'react-redux';
import { Card } from 'hui/src/styled';
import { getUserInfoForGQ } from '../selectors/user';
import { getCategories } from '../selectors/category';
import StateProvider from '../components/GetQuotes/Wizard/StateProvider';

const ConnectedWizard = connect(state => {
  return {
    categories: getCategories(state),
    user: getUserInfoForGQ(state)
  };
})(StateProvider);

export const PositionModal = styled.div`
  min-width: 480px;
  max-width: 480px;
  padding: 0;
  @media (max-width: ${props => props.theme.breakpoints.sm}rem) {
    width: 100vw;
    height: 100vh;
  }
`;

const ModalBackground = styled(Modal)`
  background-color: rgba(0, 0, 0, 0.75);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalCard = Card.extend`
  overflow-y: scroll;
  max-height: 75vh;
  -webkit-overflow-scrolling: touch;
  @media (max-width: ${props => props.theme.breakpoints.sm}rem) {
    width: 100vw;
    height: 100vh;
    padding-bottom: 64px; /* deadzone for Safari iOS menubar */
    max-height: 100vh;
    margin: 0 auto;
    border-radius: 0;
    overflow-y: scroll;
  }
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }
`;

class GetQuotesModal extends Component {
  targetElement = null;

  componentDidMount() {
    this.targetElement = document.querySelector('#modal');
  }

  showTargetElement = () => {
    disableBodyScroll(this.targetElement);
  };

  hideTargetElement = () => {
    enableBodyScroll(this.targetElement);
  };

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  render() {
    const { close, isOpen = true, initialLocation, initialCategory, ...rest } = this.props;
    return (
      <ModalBackground isOpen={isOpen} onRequestClose={close} ariaHideApp={false}>
        <PositionModal>
          <ModalCard snow p={0} m={0} id="modal">
            <ConnectedWizard
              close={close}
              initialCategory={initialCategory}
              initialLocation={initialLocation}
              {...rest}
            />
          </ModalCard>
        </PositionModal>
      </ModalBackground>
    );
  }
}

GetQuotesModal.propTypes = {
  initialLocation: PropTypes.string,
  initialCategory: PropTypes.object,
  categories: PropTypes.array,
  isOpen: PropTypes.bool,
  close: PropTypes.func
};

export default GetQuotesModal;
